// Iter XX.26 — cross-tab auth sync.
//
// When a login succeeds in Tab A, every other open Gully tab must
// detect it without a manual reload, refresh the authenticated user,
// and claim its own anonymous session. Same for logout.
//
// Primary transport: BroadcastChannel("gully-auth"). Fallback:
// localStorage `storage` event (fires in *other* tabs whenever
// localStorage changes) — handled by writing a versioned marker key
// then reading it. Both channels carry the same event shape so
// subscribers don't care which one fired.
//
// Events: { kind: "login" | "logout", at: <iso>, version: <int> }
const CHANNEL_NAME = "gully-auth";
const STORAGE_KEY = "gully_auth_broadcast";

let _bc = null;
try {
  if (typeof BroadcastChannel !== "undefined") {
    _bc = new BroadcastChannel(CHANNEL_NAME);
  }
} catch { _bc = null; }

const _listeners = new Set();

function _dispatch(evt) {
  for (const cb of _listeners) {
    try { cb(evt); } catch { /* swallow */ }
  }
}

if (_bc) {
  _bc.onmessage = (e) => { if (e && e.data) _dispatch(e.data); };
}

// Fallback — every tab listens for storage events and reacts to writes
// on our sentinel key. `storage` only fires in OTHER tabs, which is
// exactly what we want.
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key !== STORAGE_KEY || !e.newValue) return;
    try { _dispatch(JSON.parse(e.newValue)); } catch { /* swallow */ }
  });
}

export function broadcastAuthChange(kind /* "login" | "logout" */) {
  const evt = { kind, at: new Date().toISOString(), v: 1 };
  try { _bc && _bc.postMessage(evt); } catch { /* ignore */ }
  // Storage-event fallback (fires in every other tab).
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(evt));
    // Immediately clear so the next event with the same value still
    // triggers the storage listener (browsers de-dupe by value).
    setTimeout(() => {
      try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    }, 100);
  } catch { /* ignore */ }
}

export function onAuthChange(cb) {
  _listeners.add(cb);
  return () => { _listeners.delete(cb); };
}
